export const CAMPAIGNS_GRID_NAME = 'CampaignsGrid';

export const COMMAND_SHOW_CREATE_CAMPAIGN_DIALOG = 'create';

export const CAMPAIGN_EVENT_TYPE_SALE = 'SALE';
export const CAMPAIGN_EVENT_TYPE_DEPOSIT = 'DEPOSIT';
export const CAMPAIGN_EVENT_TYPE_SELLER = 'SELLER';
export const CAMPAIGN_EVENT_TYPE_WEBMASTER = 'WEBMASTER';
export const CAMPAIGN_EVENT_TYPE_DOWNLOAD = 'DOWNLOAD';
export const CAMPAIGN_EVENT_TYPE_REGISTRATION = 'REGISTRATION';
export const CAMPAIGN_EVENT_TYPE_LOGIN = 'LOGIN';
export const CAMPAIGN_EVENT_TYPE_BONUS = 'BONUS';
export const CAMPAIGN_EVENT_TYPE_ADJUST = 'ADJUST';
export const CAMPAIGN_EVENT_TYPE_SUBSCRIPTION = 'SUBSCRIPTION';
export const CAMPAIGN_EVENT_TYPE_PREMIUMTEL_SELLER = 'PREMIUMTEL_SELLER';

export const campaignEventTypes = [
  CAMPAIGN_EVENT_TYPE_SALE,
  CAMPAIGN_EVENT_TYPE_DEPOSIT,
  CAMPAIGN_EVENT_TYPE_SELLER,
  CAMPAIGN_EVENT_TYPE_WEBMASTER,
  CAMPAIGN_EVENT_TYPE_DOWNLOAD,
  CAMPAIGN_EVENT_TYPE_REGISTRATION,
  CAMPAIGN_EVENT_TYPE_LOGIN,
  CAMPAIGN_EVENT_TYPE_BONUS,
  CAMPAIGN_EVENT_TYPE_ADJUST,
  CAMPAIGN_EVENT_TYPE_SUBSCRIPTION,
  CAMPAIGN_EVENT_TYPE_PREMIUMTEL_SELLER,
];

export const campaignEventTypeLangKeys = {
  [CAMPAIGN_EVENT_TYPE_SALE]: 'campaign.event.type.sale',
  [CAMPAIGN_EVENT_TYPE_DEPOSIT]: 'campaign.event.type.deposit',
  [CAMPAIGN_EVENT_TYPE_SELLER]: 'campaign.event.type.seller',
  [CAMPAIGN_EVENT_TYPE_WEBMASTER]: 'campaign.event.type.webmaster',
  [CAMPAIGN_EVENT_TYPE_DOWNLOAD]: 'campaign.event.type.download',
  [CAMPAIGN_EVENT_TYPE_REGISTRATION]: 'campaign.event.type.registration',
  [CAMPAIGN_EVENT_TYPE_LOGIN]: 'campaign.event.type.login',
  [CAMPAIGN_EVENT_TYPE_BONUS]: 'campaign.event.type.bonus',
  [CAMPAIGN_EVENT_TYPE_ADJUST]: 'campaign.event.type.adjust',
  [CAMPAIGN_EVENT_TYPE_SUBSCRIPTION]: 'campaign.event.type.subscription',
  [CAMPAIGN_EVENT_TYPE_PREMIUMTEL_SELLER]: 'campaign.event.type.premiumtel-seller',
};

export const CAMPAIGN_STATUS__PENDING = 'PENDING';
export const CAMPAIGN_STATUS__ACTIVE = 'ACTIVE';
export const CAMPAIGN_STATUS__SUSPENDED = 'SUSPENDED';
export const CAMPAIGN_STATUS__DELETED = 'DELETED';
export const CAMPAIGN_STATUS__LOCKED = 'LOCKED';
export const CAMPAIGN_STATUS__DELETED_WITH_WEBMASTER = 'DELETED_WITH_WEBMASTER';

export const campaignStatuses = [
  CAMPAIGN_STATUS__PENDING,
  CAMPAIGN_STATUS__ACTIVE,
  CAMPAIGN_STATUS__SUSPENDED,
  CAMPAIGN_STATUS__DELETED,
  CAMPAIGN_STATUS__LOCKED,
  CAMPAIGN_STATUS__DELETED_WITH_WEBMASTER,
];

export const campaignStatusLangKeys = {
  [CAMPAIGN_STATUS__PENDING]: 'campaign.status.pending',
  [CAMPAIGN_STATUS__ACTIVE]: 'campaign.status.active',
  [CAMPAIGN_STATUS__SUSPENDED]: 'campaign.status.suspended',
  [CAMPAIGN_STATUS__DELETED]: 'campaign.status.deleted',
  [CAMPAIGN_STATUS__LOCKED]: 'campaign.status.locked',
  [CAMPAIGN_STATUS__DELETED_WITH_WEBMASTER]: 'campaign.status.deleted-with-webmaster',
};
